var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 43.998,
    viewBox: "0 0 44 43.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BZYGmV",
    transform: "translate(-0.001 334.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 -335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    className: "cls-1",
    d: "M24000,24148a21.956,21.956,0,1,1,8.563-1.73A21.8,21.8,0,0,1,24000,24148Zm-4.32-29.562a6.6,6.6,0,0,0-5.066,2.764,9.5,9.5,0,0,0-1.654,5.854,17.388,17.388,0,0,0,1.121,5.668,17.173,17.173,0,0,0,3.684,6.041,3.326,3.326,0,0,0,2.248,1.078.317.317,0,0,1,.041,0l.018,0a.2.2,0,0,0,.033,0,4.729,4.729,0,0,0,1.947-.541l.006,0a5.91,5.91,0,0,1,2.525-.65,4.973,4.973,0,0,1,2.332.617l.01,0a4.5,4.5,0,0,0,2.082.566,3.583,3.583,0,0,0,2.672-1.4,18.2,18.2,0,0,0,3.365-6.152,6.19,6.19,0,0,1-1.846-1.287,6.113,6.113,0,0,1-1.816-4.518,6.329,6.329,0,0,1,1.488-4.008,6.809,6.809,0,0,1,1.445-1.32l.012-.006a6.061,6.061,0,0,0-1.3-1.412,6.312,6.312,0,0,0-4-1.412,7.292,7.292,0,0,0-3.25.854,3.9,3.9,0,0,1-1.572.5h-.008a3.784,3.784,0,0,1-1.605-.486l-.02-.01A6.15,6.15,0,0,0,23995.68,24118.438Zm9.7-6.924v0h0a6.173,6.173,0,0,0-3.855,1.982,6.062,6.062,0,0,0-1.541,4.523,1.319,1.319,0,0,0,.334.027,4.82,4.82,0,0,0,3.449-1.709,6.483,6.483,0,0,0,1.619-4.82Z",
    transform: "translate(-23978 -24104)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.df0d8f89.svg";
export { ForwardRef as ReactComponent };